import React from 'react';

import { cn } from 'lib/helpers/utility';

import Loader from 'components/shared/Loader/Loader';

import { useSubModal } from '../../lib/SubModalContext';

import Details from './Details';
import TabTable from './TabTable';

const TabsTableContent = ({
  tab,
  isLoading,
  setModal,
  modalValue,
  setModalValue,
  selectedData,
  onSubmit,
  alwaysShowDetails,
  showDetails,
  details,
  setDetails,
  prefix,
  setSelected,
  setFetchedData,
  selected,
  fetchedData,
  insideBodyClassName,
  contentValues,
  setContentValue
}) => {
  const { openSubModal, closeSubModal } = useSubModal();

  const setValue = (key, value) => {
    setModalValue((old) => ({ ...old, [key]: value }));
  };

  const openModal = (modalProps) => {
    setModal(modalProps);

    const handleModalClose = () => {
      setModal(null);
      closeSubModal();
    };

    const submitFn = modalProps?.onSubmit || onSubmit;
    const isDisabled = modalProps?.disabled || modalProps?.disableSubmit;

    openSubModal({
      title: modalProps?.title,
      className: modalProps?.contentClassName,
      panelClassName: modalProps?.height ? `h-[${modalProps.height}]` : '',
      content: modalProps?.content ? (
        <modalProps.content
          setValue={setValue}
          values={modalValue}
          setModalValue={setModalValue}
          selected={selectedData}
          close={handleModalClose}
        />
      ) : null,
      footer: modalProps?.footer
        ? typeof modalProps.footer === 'function'
          ? modalProps.footer({ onClose: handleModalClose })
          : modalProps.footer
        : undefined,
      actions: {
        ...(submitFn && {
          text: modalProps?.submitText || 'Submit',
          onClick: async () => {
            const result = await submitFn?.(modalValue);
            if (result !== false) {
              setModalValue({});
              setModal(null);
              closeSubModal();
            }
          },
          isDisabled: typeof isDisabled === 'function' ? !!isDisabled(modalValue) : !!isDisabled
        }),
        onClose: handleModalClose
      }
    });
  };

  return (
    <div className="flex h-full w-full">
      <div className="flex h-full w-full flex-col">
        {tab?.table?.topComponent && (
          <div className="w-full pt-2">
            <tab.table.topComponent
              data={fetchedData}
              contentValues={contentValues}
              setContentValue={setContentValue}
            />
          </div>
        )}
        {!!tab?.component && !isLoading && (
          <tab.component selected={selectedData} openModal={openModal} />
        )}
        {!!!tab?.component && (
          <div
            className={cn(
              'mx-4 my-2 flex h-full flex-col rounded-md border border-solid border-neutral-200',
              insideBodyClassName
            )}>
            <TabTable
              tab={tab}
              alwaysShowDetails={alwaysShowDetails}
              setDetails={setDetails}
              prefix={prefix}
              setSelected={setSelected}
              setFetchedData={setFetchedData}
              selected={selected}
              contentValues={contentValues}
            />

            {isLoading && (
              <div className="flex h-full w-full items-center justify-center">
                <Loader color="primary" size={48} />
              </div>
            )}
          </div>
        )}
      </div>
      <Details
        tab={tab}
        setDetails={setDetails}
        details={details}
        alwaysShowDetails={alwaysShowDetails}
        showDetails={showDetails}
      />
    </div>
  );
};

export default TabsTableContent;
